import './CinematicContainer.css';

export const CinematicContainer = ({ imgSrc, title, onClick, class_Name, styles}) => {
  // Detect if the file is a video based on common extensions
  const isVideo = /\.(mp4|webm|ogg|mov|m4v)($|\?)/i.test(imgSrc);

  return (
    <div className={`cinematic-container ${class_Name}`} style={styles} onClick={onClick}>
      {isVideo ? (
        <video 
          src={imgSrc} 
          className="bg-asset" 
          autoPlay 
          loop 
          muted 
          playsInline 
        />
      ) : (
        <img 
          src={imgSrc} 
          alt="Cinematic Background" 
          className="bg-asset" 
        />
      )}
      <div className="title-overlay">
        <h1>{title}</h1>
      </div>
    </div>
  );
};

export default CinematicContainer;
